module.exports = __webpack_public_path__ + "assets/life_tel_v1.7075061a.svg";